import React from "react";

function AddedSuccessfulMember({ isMember, setOpenSuccessfull, setInAddingMode }) {
    return (
        <>
            <div className=" successful_create_transprant_body ">
                <div className=" p-2 successful_create_container shadow">
                    <img src="images/Ellipse 208.svg" alt="" />
                    {isMember ? (<span className=" my-4 successfully_create_message">
                        Members added successfully.
                    </span>) : (
                        <span className=" my-4 successfully_create_message">
                            {/* You have successfully created the channel */}
                            {`Member Added Successfully`}
                        </span>
                    )}
                    <button
                        onClick={() => {
                            setOpenSuccessfull(false)
                            setInAddingMode(false)
                        }}
                        className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
                    >
                        Okay
                    </button>
                </div>
            </div>
        </>
    )
}

export default AddedSuccessfulMember;
